import script from "./PermissionRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionRequestModal.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionRequestModal.vue?vue&type=style&index=0&id=c974f69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c974f69c"]])

export default __exports__